import adze from './log.js';
export * from './configuration.js';
import Formatter from './formatters/formatter.js';
import { setup, teardown, isBrowser, addPadding, applyStyles, formatAssert, formatCount, formatIf, formatLabel, formatNamespace, initialCaps, } from './functions/index.js';
export * from './middleware.js';
export * from './formatters/common/index.js';
export * from './formatters/standard/index.js';
export * from './formatters/json/index.js';
import { console_styles, } from './_types/index.js';
export { Formatter, addPadding, applyStyles, console_styles, formatAssert, formatCount, formatIf, formatLabel, formatNamespace, initialCaps, isBrowser, setup, teardown, };
export * from './constants.js';
export default adze;
